<template>
    <div>
        <FacilityInfoWin ref="facilityInfoWin"
                         v-on:loaded-facility-info="loadedFacilityInfoHandle" />
    </div>
</template>

<script>
import { $_TYPE, $_NM, $_WC } from '@/confs/common.const';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { mapGetters } from "vuex";
import FacilityInfoWin from '@/views/lfcnvnc/apart/LfcnvncApartInfoWin.vue';
import gripUtil from "@/libs/grip.util";

export default {
    components: {
        FacilityInfoWin,
    },
    data() {
        return {
            // map: undefined,
        }
    },
    computed: {
        ...mapGetters({
            selectedLfcnvncTab: 'getSelectedLfcnvncTab',
            selectedDate: 'getSelectedDate',
            apartMap: 'getApartMap',
            recognizer: 'getRecognizer',
        }),
    },
    created() {
        this.$eventBus.$on("NaverMap::map-loaded", (map)=>{
        //     // this.map = map;
            this.setRecognizer();
        //     // recognizer 확인용
        //     this.$nextTick(() => {
        //         console.log('recognizer', this.recognizer);
        //     });
        });
        this.$eventBus.$on('Set::Apt::Facility::Info', (fac)=> {
            this.$refs.facilityInfoWin.setFacilityInfo(fac);
        });

        this.$eventBus.$on('LfcnvncApp::loaded-data',() => {
            this.$nextTick(() => {
                this.setAptMarker();
            });
        });
    },
    watch: {
        selectedDate: {
            immediate: true,
            handler(newVal, oldVal) {
                if(!!newVal) {
                    // console.log('markerMap', this.markerMap['apart']);
                    if(!!this.markerMap['apart']) {
                        this.markerMap['apart'].forEach(d => {
                            if(d.title == newVal && d.title != this.selectedMarker.title) {
                                this.selectAptMarker(d);
                            }
                        })
                    }
                }
            }
        },
        selectedLfcnvncTab: {
            immediate: false,
            handler(newVal, oldVal) {
                this.map.setZoom(13);
                let centerLat = 37.493712000000002;
                let centerLng = 127.06533399999999;
                this.map.setCenter(new naver.maps.LatLng(centerLat, centerLng));
                if(!!newVal && newVal == 'apart') {
                    this.$nextTick(() => {
                        this.setAptMarker();
                    });
                }
            }
        },
    },
    methods: {
        setAptMarker() {
            if(!!this.map && !!this.selectedDate && this.selectedLfcnvncTab == 'apart') {
                this.disableAllMarker();
                let basdtVal = this.selectedDate;
                let dataName = '아파트 매매';
                let dataList = [];
                for(let key in this.apartMap) {
                    for(let k in this.apartMap[key]) {
                        dataList.push(this.apartMap[key][k][0]);
                    }
                }
                this.$nextTick(()=> {
                    if(!!dataList) {
                        if(!this.hasMarkers('apart')) {
                            // let dataList = this.aptMap[this.selectedDate];
                            dataList.forEach(data => {
                                // 시설 정보 팝업
                                data.facItemNm = dataName;
                                let imgNm = '1212_apart';
                                // console.log('imgNm', imgNm);
                                // console.log('data', data);
                                let position = new naver.maps.LatLng(data.lttdVal, data.lgtdVal);
                                data.marker = this.makeMarker('apart', data, function(){
                                    this.$refs.facilityInfoWin.setFacilityInfo(data);
                                    this.$eventBus.$emit("Change::Dong", data.val8.trim());
                                    this.$store.dispatch('SET_SELECTED_DATE', data.val5);
                                    this.map.setCenter(position);
                                }.bind(this), 'marker_facility_' + imgNm + '.png', 'img/marker2/', $_NM.MARKER2_W, $_NM.MARKER2_H, data.val5);
                                // data.marker.title = '('+ data.val2 + '.' + data.val3 + '.' + data.val4 + '-' + data.val10 + '층) ' + data.val5;
                                // data.marker.title = data.val5;
                                // this.recognizer.add(data.marker);
                            });
                            this.showMarkers('apart', true);
                        } else {
                            this.showMarkers('apart', true);
                        }
                    }
                });
            }
        },
        loadedFacilityInfoHandle(content) {
            this.openInfoWin(content);
        },
        selectAptMarker(marker) {
            this.$store.dispatch("SET_SELECTED_MARKER", marker);
            this.$refs.facilityInfoWin.setFacilityInfo(marker.data);
            this.map.setCenter(marker.position);
            this.map.setZoom(15);
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
